// assets
import MenuApply from 'ui-component/icons/menuApply';
import MenuList from 'ui-component/icons/menuList';
import MenuTransition from 'ui-component/icons/menuTransition';
import { Menu } from './type';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard: Menu = {
  id: 'card',
  title: '我的卡片',
  i18nTitle: 'card',
  type: 'group',
  children: [
    {
      id: 'apply',
      title: '技术开卡',
      i18nTitle: 'apply',
      type: 'item',
      url: '/cards/create',
      icon: MenuApply,
      breadcrumbs: false
    },
    {
      id: 'cardList',
      title: '卡片列表',
      i18nTitle: 'cardList',
      type: 'item',
      url: '/cards/list',
      icon: MenuList,
      breadcrumbs: false
    },
    {
      id: 'cardTransition',
      title: '交易明细',
      i18nTitle: 'cardTransition',
      type: 'item',
      url: '/cards/transaction',
      icon: MenuTransition,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
